import { formatSection } from "./wordFormatting";
import { applyDraftStyle } from "@/lib/styleService";
import Logger from "@/utility/logger";
import { TODO_TEXT_COLOR } from "@/utility/captionTodoColor";
import { resolveTodoSpanRanges } from "./wordTodoSpan";
import { replaceTaskItemTokens } from "@/utility/taskItem";


// Retrieves the selected text in the Word document and finds the closest bookmark before the selection
export const getSelectedText = async () => {
  const selectedText = await Word.run(async (context) => {
    const selection = context.document.getSelection();
    selection.load("text");
    context.load(selection);

    await context.sync();

    if (selection.isEmpty) {
      Logger.debug("wordText.ts: No text selection is active.");
      return "";
    }

    Logger.debug("wordText.ts: Selected text:", selection.text);
    return selection.text;
  }).catch(function (error) {
    Logger.error("wordText.ts: Error reading selected text: ", error);
  });

  // const orderedBookmarkNames = await getAllBookmarks();

  // const closestBookmark = await Word.run(async (context) => {
  //   // 1. Get the current selection range.
  //   const selectionRange = context.document.getSelection();
  //   context.load(selectionRange);
  //   await context.sync();

  //   // If there's no active selection, we cannot determine a closest bookmark.
  //   if (selectionRange.isEmpty) {
  //     console.log("No text selection is active.");
  //     return null;
  //   }

  //   // 2. Use the provided orderedBookmarkNames array.
  //   const allBookmarkNames = orderedBookmarkNames;

  //   if (allBookmarkNames.length === 0) {
  //     console.log("Provided bookmark names array is empty. Cannot find closest bookmark.");
  //     return null;
  //   }

  //   let closestBookmark = null;
  //   let minDistance = Number.MAX_SAFE_INTEGER; // Initialize with a very large number

  //   const bookmarkRange1 = context.document.getBookmarkRangeOrNullObject(allBookmarkNames[9]);
  //   const bookmarkRange2 = context.document.getBookmarkRangeOrNullObject(allBookmarkNames[16]);
  //   const bookmarkRange3 = context.document.getBookmarkRangeOrNullObject(allBookmarkNames[21]);
  //   bookmarkRange1.load("isNullObject");
  //   bookmarkRange2.load("isNullObject");
  //   bookmarkRange3.load("isNullObject");
  //   await context.sync();
  //   console.log(`Bookmark 1: ${allBookmarkNames[9]}, Bookmark 2: ${allBookmarkNames[16]}, Bookmark 3: ${allBookmarkNames[1]}`);

  //   // console.log("Bookmark 1:", bookmarkRange1, "Selection:", selectionRange);

  //   const relation0 = selectionRange.compareLocationWith(bookmarkRange1);
  //   const relation1 = bookmarkRange1.compareLocationWith(selectionRange);
  //   const relation2 = selectionRange.compareLocationWith(selectionRange);
  //   const relation3 = selectionRange.compareLocationWith(bookmarkRange2);
  //   const relation4 = bookmarkRange2.compareLocationWith(bookmarkRange1);
  //   const relation5 = bookmarkRange2.compareLocationWith(bookmarkRange3);
  //   const relation6 = bookmarkRange3.compareLocationWith(bookmarkRange1);
  //   await context.sync();
  //   console.log(relation0);
  //   console.log(relation1);
  //   console.log(relation2);
  //   console.log(relation3);
  //   console.log(relation4);
  //   console.log(relation5);
  //   console.log(relation6);

  //   // 3. Iterate through each bookmark name from the provided array
  //   // and try to retrieve the actual Bookmark object to compare its range.
  //   // for (const bookmarkName of allBookmarkNames) {
  //   //   // Use getByNameOrNullObject to get the Bookmark object by its name.
  //   //   console.log(`Checking bookmark: ${bookmarkName}`);
  //   //   const bookmarkRange = context.document.getBookmarkRangeOrNullObject(bookmarkName);
  //   //   bookmarkRange.load("isNullObject");
  //   //   await context.sync();

  //   //   // If the bookmark object was successfully retrieved (i.e., not null/deleted)
  //   //   if (!bookmarkRange.isNullObject) {
  //   //     console.log(`Found bookmark: ${bookmarkName}`);

  //   //     const bookmarkEndPoint = bookmarkRange.getRange(Word.RangeLocation.end);
  //   //     const selectionStartPoint = selectionRange.getRange(Word.RangeLocation.start);

  //   //     // Compare the bookmark's end point with the selection's start point.
  //   //     const relation = bookmarkEndPoint.compareLocationWith(selectionStartPoint);
  //   //     await context.sync();

  //   //     console.log(relation);

  //   //     // If the bookmark is strictly before the selection, it's a candidate.
  //   //     if (relation.value === Word.LocationRelation.before) {
  //   //       // Calculate the distance: create a range from the end of the bookmark to the start of the selection.
  //   //       const gapStartPoint = selectionRange.getRange(Word.RangeLocation.start);
  //   //       // Create a collapsed range at the end of the bookmark.
  //   //       const gapEndPoint = bookmarkRange.getRange(Word.RangeLocation.end);

  //   //       // Expand the selection's start point range backwards to include the bookmark's end point.
  //   //       // This creates a range that spans the content between the two points.
  //   //       gapStartPoint.expandTo(gapEndPoint);
  //   //       gapStartPoint.load("text");
  //   //       await context.sync();

  //   //       // The distance is the number of characters in this newly formed 'gap' range.
  //   //       const distance = gapStartPoint.text.length;
  //   //       console.log(distance, bookmarkName);

  //   //       // If this bookmark is closer than the previously found closest one, update.
  //   //       if (distance < minDistance) {
  //   //         minDistance = distance;
  //   //         closestBookmark = bookmarkName;
  //   //       }
  //   //     }
  //   //     // Optimization: Since `orderedBookmarkNames` is ordered, if we find a bookmark
  //   //     // that is *after* or *contains* the selection, any subsequent bookmarks in the
  //   //     // list will also be after, so we can stop searching for 'before' bookmarks.
  //   //     // else if (relation.value === Word.LocationRelation.after ||
  //   //     //          relation.value === Word.LocationRelation.contains ||
  //   //     //          relation.value === Word.LocationRelation.equal) {
  //   //     //     // No need to continue checking further bookmarks as they will be after the selection
  //   //     //     // or we've already found one.
  //   //     //     break;
  //   //     // }
  //   //   }
  //   // }

  //   if (closestBookmark) {
  //     console.log(`Closest bookmark found before selection: "${closestBookmark.name}" (Distance: ${minDistance} characters)`);
  //   } else {
  //     console.log("No bookmark found before the selection.");
  //   }

  //   return closestBookmark;
  // });

  const closestBookmark = "";

  return { selectedText, closestBookmark };
};

// Checks if there is any selected text in the Word document
export const isSelectedText = async () => {
  const bool = await Word.run(async (context) => {
    const selection = context.document.getSelection();
    context.load(selection);

    await context.sync();

    if (selection.isEmpty) {
      // console.log("No text selection is active.");
      return false;
    }

    return true;
  }).catch(function (error) {
    Logger.error("wordText.ts: Error reading selected text: ", error);
  });

  return bool;
};

// Inserts text at the current selection in the Word document in chunks of a specified size
export const insertTextAtSelection = async (textToInsert: string, chunkSize: number) => {
  await Word.run(async (context) => {
    const selection = context.document.getSelection();
    selection.load("isEmpty");
    await context.sync();

    if (selection.isEmpty) {
      Logger.debug("wordText.ts: No text selection is active.");
      return;
    }

    let insertionPoint = selection.insertText("", Word.InsertLocation.replace);
    await context.sync();

    for (let i = 0; i < textToInsert.length; i += chunkSize) {
      const chunk = textToInsert.slice(i, i + chunkSize);
      const chunkRange = insertionPoint.insertText(chunk, Word.InsertLocation.end);
      chunkRange.font.color = "black";
      await context.sync();
      insertionPoint = chunkRange;
    }
  });
};

// Inserts text at a specific bookmark in the Word document
export const insertTextAtSection = async (
  targetWord: string,
  textToInsert: string,
  chunkSize: number,
  setGeneratedSections,
  sectionStatus,
  section
) => {
  await Word.run(async (context) => {
    if (Office.context.diagnostics.platform === Office.PlatformType.OfficeOnline) {
      const startBookmark = context.document.getBookmarkRangeOrNullObject(targetWord + "_START");
      const endBookmark = context.document.getBookmarkRangeOrNullObject(targetWord + "_END");

      startBookmark.load("isNullObject, end");
      endBookmark.load("isNullObject");
      await context.sync();

      if (startBookmark.isNullObject || endBookmark.isNullObject) {
        Logger.warn("wordText.ts: One or both bookmarks were not found.", targetWord);
        return;
      }

      const combinedRange = startBookmark.expandTo(endBookmark);
      combinedRange.load("text");
      await context.sync();

      const searchResults = combinedRange.search("Jenly.AI generated content will be inserted here.", {
        matchCase: false,
        matchWholeWord: true,
        ignorePunct: true,
      });

      searchResults.load("items");
      await context.sync();

      if (searchResults.items.length > 0) {
        Logger.debug("wordText.ts: Found placeholder phrase after bookmark:", targetWord);
        searchResults.items[0].insertText(" ", Word.InsertLocation.replace);
        await context.sync();
      }

      combinedRange.clear();

      const bookmarkRange = context.document.getBookmarkRangeOrNullObject(targetWord + "_START");

      bookmarkRange.load("isNullObject");
      await context.sync();

      if (bookmarkRange.isNullObject) {
        Logger.error("wordText.ts: Bookmark not found!", targetWord);
        return;
      }

      const paragraph = bookmarkRange.insertParagraph("", Word.InsertLocation.after);
      await context.sync();

      let insertionPoint: Word.Range = paragraph.getRange(Word.RangeLocation.end);

      for (let i = 0; i < textToInsert.length; i += chunkSize) {
        const chunk = textToInsert.slice(i, i + chunkSize);
        const chunkRange = insertionPoint.insertText(chunk, Word.InsertLocation.end);

        // apply font draft style from styleService
        await applyDraftStyle(chunkRange);

        chunkRange.paragraphs.getFirst().alignment = Word.Alignment.left;
        chunkRange.paragraphs.getFirst().lineSpacing = 14;
        chunkRange.paragraphs.getFirst().spaceBefore = 0;
        chunkRange.paragraphs.getFirst().spaceAfter = 7;

        await context.sync();

        insertionPoint = chunkRange;
      }
    } else {
      const startBookmark = context.document.getBookmarkRangeOrNullObject(targetWord + "_START");
      const endBookmark = context.document.getBookmarkRangeOrNullObject(targetWord + "_END");

      startBookmark.load("isNullObject, end");
      endBookmark.load("isNullObject");
      await context.sync();

      if (startBookmark.isNullObject || endBookmark.isNullObject) {
        Logger.warn("wordText.ts: One or both bookmarks were not found.", targetWord);
        return;
      }

      const combinedRange = startBookmark.expandTo(endBookmark);
      combinedRange.load("text");
      await context.sync();

      const searchResults = combinedRange.search("Jenly.AI generated content will be inserted here.", {
        matchCase: false,
        matchWholeWord: true,
        ignorePunct: true,
      });

      searchResults.load("items");
      await context.sync();

      if (searchResults.items.length > 0) {
        Logger.debug("wordText.ts: Found placeholder phrase after bookmark:", targetWord);
        searchResults.items[0].insertText(" ", Word.InsertLocation.replace);
        await context.sync();
      }

      const bookmarkRange = context.document.getBookmarkRangeOrNullObject(targetWord + "_START");

      bookmarkRange.load("isNullObject");
      await context.sync();

      if (bookmarkRange.isNullObject) {
        Logger.error("wordText.ts: Bookmark not found!", targetWord);
        return;
      }

      const paragraph = bookmarkRange.insertParagraph("", Word.InsertLocation.after);
      await context.sync();

      let insertionPoint: Word.Range = paragraph.getRange(Word.RangeLocation.end);

      for (let i = 0; i < textToInsert.length; i += chunkSize) {
        const chunk = textToInsert.slice(i, i + chunkSize);

        const chunkRange = insertionPoint.insertText(chunk, Word.InsertLocation.end);
        // chunkRange.style = "Drafting Notes (Agency)";
        applyDraftStyle(chunkRange);
        chunkRange.paragraphs.getFirst().alignment = Word.Alignment.left;
        chunkRange.paragraphs.getFirst().lineSpacing = 14;
        chunkRange.paragraphs.getFirst().spaceBefore = 0;
        chunkRange.paragraphs.getFirst().spaceAfter = 7;

        await context.sync();

        insertionPoint = chunkRange;
      }

      if (!combinedRange.isNullObject && combinedRange.text && combinedRange.text.length > 0) {
        const paragraphs = combinedRange.paragraphs;
        paragraphs.load("items");
        await context.sync();

        Logger.debug("wordText.ts: Paragraphs found:", paragraphs.items.length);

        let emptyCount = 0;

        for (let i = 0; i < paragraphs.items.length; i++) {
          const para = paragraphs.items[i];
          const text = para.text.trim();

          if (text === "") {
            emptyCount++;
            if (emptyCount > 0) para.delete();
          } else {
            emptyCount = 0;
          }
        }
      }
    }
  });
  setGeneratedSections((prev) => [...prev, section]);
  sectionStatus[section.id] = true;
  formatSection(targetWord);
};

// Inserts text at a specific insertion key phrase in the Word document
export const insertTextAtKey = async (resolvedOutputs) => {
  await Word.run(async (context) => {
    const sections = context.document.sections;
    sections.load("items/pageSetup/differentFirstPageHeaderFooter, items/pageSetup/oddAndEvenPagesHeaderFooter");
    await context.sync();

    const searchScope = [];

    for (const resolvedOutput of resolvedOutputs) {
      const targetWord = resolvedOutput.insertion_key;
      const textToInsert = replaceTaskItemTokens(resolvedOutput.output, "markers");

      if (!targetWord || !textToInsert) continue;

      const bodyResults = context.document.body.search(targetWord, {
        matchCase: false,
        matchWholeWord: true,
        ignorePunct: true,
      });
      bodyResults.load("items/paragraphs/style, items/paragraphs/uniqueLocalId");
      searchScope.push({ type: "body", search: bodyResults, textToInsert: textToInsert });

      for (let i = 0; i < sections.items.length; i++) {
        const section = sections.items[i];

        const targets = [];

        targets.push(section.getHeader("Primary"));
        targets.push(section.getFooter("Primary"));

        if (section.pageSetup.differentFirstPageHeaderFooter) {
          targets.push(section.getHeader("FirstPage"));
          targets.push(section.getFooter("FirstPage"));
        }

        if (section.pageSetup.oddAndEvenPagesHeaderFooter) {
          targets.push(section.getHeader("EvenPages"));
          targets.push(section.getFooter("EvenPages"));
        }

        for (const target of targets) {
          const results = target.search(targetWord, {
            matchCase: false,
            matchWholeWord: true,
          });
          results.load("items/paragraphs/uniqueLocalId");
          searchScope.push({ type: "headersFooters", search: results, textToInsert: textToInsert });
        }
      }
    }

    Logger.debug(`wordText.ts: Executing batch search for ${resolvedOutputs.length} keys across document...`);
    await context.sync();

    const todoSearches = [];
    const processedParagraphs = new Set();

    for (const scope of searchScope) {
      const firstInstanceOfParagraph = new Set();

      for (const insertionkeyRange of scope.search.items) {
        const firstParagraph = insertionkeyRange.paragraphs.items[0];
        const paragraphId = firstParagraph ? firstParagraph.uniqueLocalId : "unknown";

        // "insertionKeyKey" tracks specific keys location (paragraph location + placeholders name) within a paragraph
        // there is at least one instance that insertionKeyKey per paragraph
        /**
         * allows replacing multiple instances of placeholders in one paragraph (e.g., "Hi {placeholder}, bye {placeholder}"), while preventing duplicate processing in complex areas like linked headers
         */
        const insertionKeyKey = `${paragraphId}_${scope.textToInsert}`;

        // if processed globally (processedParagraphs), check if we are still inside the "first instance" of that paragraph
        // - if in firstInstanceOfParagraph: This is a 2nd+ match in the SAME paragraph, so we SHOULD process it
        // - if NOT in firstInstanceOfParagraph: This is a subsequent linked instance (e.g., linked header on Page 2), so we skip it
        if (processedParagraphs.has(insertionKeyKey) && !firstInstanceOfParagraph.has(insertionKeyKey)) {
          continue;
        }

        let shouldReplace = false;

        if (scope.type === "body") {
          const style = firstParagraph?.style?.toLowerCase() || "";
          if (style !== "toc 1" && style !== "toc 2" && style !== "toc 3") {
            shouldReplace = true;
          } else {
            // SPECIAL CASE: Table of Contents (TOC) Protection
            // Placeholders often appear in Headers (e.g., Heading 1). Word mirrors this text
            // into the TOC automatically. We explicitly skip replacement inside the TOC because:
            // 1. The TOC is a calculated field. Manual edits here are temporary and will be
            //    overwritten the next time the user clicks "Update Table".
            // 2. We only need to update the source Header; the TOC will reflect the correct
            //    text once the field is updated.
            Logger.debug(`wordText.ts: Skipping replacement in TOC for key: ${scope.textToInsert}`);
          }
        } else if (scope.type === "headersFooters") {
          shouldReplace = true;
        }

        if (shouldReplace === true) {
          insertionkeyRange.insertText(scope.textToInsert, Word.InsertLocation.replace);
          insertionkeyRange.font.color = "black";

          processedParagraphs.add(insertionKeyKey);
          firstInstanceOfParagraph.add(insertionKeyKey);
        }

        if (scope.textToInsert && /TODO[:.]/i.test(scope.textToInsert)) {
          const todoResults = insertionkeyRange.search("TODO:", { matchCase: false });
          todoResults.load("items/font");
          todoSearches.push(todoResults);

          const todoDotResults = insertionkeyRange.search("TODO.", { matchCase: false });
          todoDotResults.load("items/font");
          todoSearches.push(todoDotResults);
        }
      }
    }

    await context.sync();

    if (todoSearches.length > 0) {
      const todoMatches = todoSearches.flatMap((results) => results.items);
      const todoRanges = await resolveTodoSpanRanges(context, todoMatches);
      for (const todoRange of todoRanges) {
        // Style TODO placeholder text in Word in red-orange (#c2410c)
        // matching the add-in UI treatment, with bold weight and no
        // yellow background highlight.
        todoRange.font.color = TODO_TEXT_COLOR;
        todoRange.font.bold = true;
        todoRange.font.highlightColor = null;
      }
      await context.sync();
    }
  });
};

// Inserts text incrementally into the Word document in chunks of a specified size
export const insertTextIncrementally = async (text: string, chunkSize: number) => {
  await Word.run(async (context) => {
    const body = context.document.body;
    let currentRange = body.insertText("", Word.InsertLocation.end);

    for (let i = 0; i < text.length; i += chunkSize) {
      const chunk = text.slice(i, i + chunkSize);
      currentRange.insertText(chunk, Word.InsertLocation.end);
      await context.sync();
    }
  });
};
